import { observer, Observer } from "mobx-react";
import { Dialog } from "primereact/dialog";
import * as React from "react";
import { useLocStore } from "../localization";
import { LocContext } from "../localization/LocContext";
import { pluginComponentStore } from "../utils/PluginComponents";
import { IWsSentryReportArgs } from "./wsSentry";
import { wsSentryReport } from "./wsSentryReport";

function removeScriptTags(s) {
  const div = document.createElement("div");
  div.innerHTML = s + "";
  const scripts = div.getElementsByTagName("script");
  let i = scripts.length;
  while (i--) {
    scripts[i].parentNode.removeChild(scripts[i]);
  }
  return div.innerHTML;
}

export const showSentryDialog = (args: IWsSentryReportArgs) => {
  const {
    correlationId,
    simpleMessage,
    alreadyReportedToSentry = false,
  } = args;

  let eventId2;
  if (!alreadyReportedToSentry) {
    eventId2 = wsSentryReport({
      tag: "wsErrorDialog",
      simpleMessage,
      ...args,
    });
  }

  const dialog = observer(() => {
    const L = useLocStore(LocContext.GENERAL);

    return (
      <Dialog
        visible
        onHide={() => {
          pluginComponentStore.remove(dialogKey);
        }}
        header={L.id("a6deb97a6b53").loc("Noe gikk galt")}
      >
        <div
          className="p-inline-message p-inline-message-error"
          style={{
            display: "block",
            whiteSpace: "pre-wrap",
            padding: "5px",
            maxWidth: "800px",
            width: "400px",
            wordBreak: "break-word",
          }}
        >
          <div>{removeScriptTags(simpleMessage)}</div>
          <div>CorrelationId: {correlationId || ""}</div>
        </div>
      </Dialog>
    );
  });

  const dialogKey = pluginComponentStore.add(dialog);
};
